import React, { useEffect, useState, Fragment } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import { ArrowRight, Filter, tick } from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ModalPop from 'components/sales/modal/modal';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import Images from 'assets/images/imageData';
import DropDown from 'components/sales/Input/dropdown1/dropDown';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import TextAreaInput from 'components/sales/Input/textAreaInput/textAreaInput';
import  { toast } from 'react-toastify';

const ContractExpiryList = ({
  getSiteList,
  siteList,
  getFilters,
  filters,
  updateClientRenewalStatus,
  clientStatusUpdate=[],
  getClientStatusOptions,
  clientStatusOptions=[]
}) => {

  const headers = [
    "Site Id",
    'Site number',
    'Site Name',
    // 'Client Name',
    'Project type',
    'Project ID',
    'City',
    'Live date',
    'Expiry date',
    'Site type',
    'RM Name',
    'Site Status',
    'Renewal Status',
    'Actions'
  ];
  const [listData, setListData] = useState();
  const [activePostSales, setActivePostSales] = useState();
  const [teamId, setTeamId] = useState();
  const [departmentId, setDepartmentId] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [isStatusSuccess, setIsStatusSuccess] = useState(false);
  const [isRoleId, setIsRoleId] = useState(null);
  const [contractStatusModalOpenForContractExpiry, setContractStatusModalOpenForContractExpiry] =useState(false);
  const [requestForContractExpiry,setRequestForContractExpiry] = useState(null);
  const [contractExpiryStatus,setContractExpiryStatus]=useState({
    site_id:'',
    client_status: '',
    client_status_reason: '',
    client_status_reason_remarks:''
  });

  const [isSuccessModal,setIsSuccessModel]=useState(false);
  const [isFailureModal,setIsFailureModel]=useState(false);

  useEffect(() => {
    (async () => {
      const roles = await JSON.parse(localStorage.getItem('roles'));
      roles && setIsRoleId(roles[0].pivot.role_id);
    })();
  }, []);

  const createLead = async () => {
    if (departmentId && departmentId === 2) {
      if (teamId && teamId === 7) {
        setActivePostSales('post-sales-corporate');
      } else if (teamId && teamId === 9) {
        setActivePostSales('post-sales-supply');
      } else if (teamId && teamId === 8) {
        setActivePostSales('post-sales-apartment');
      } else {
        setActivePostSales('post-sales-b2b-alliance');
      }
    }
  };

  useEffect(() => {
    (async () => {
      const team =
        (await JSON.parse(localStorage.getItem('profileDetails'))) &&
        JSON.parse(localStorage.getItem('profileDetails'))[0].team_id;
      const deparment =
        (await JSON.parse(localStorage.getItem('profileDetails'))) &&
        JSON.parse(localStorage.getItem('profileDetails'))[0].department_id;
      setTeamId(team);
      setDepartmentId(deparment);
    })();
  }, []);

  useEffect(() => {
    if (teamId && departmentId) {
      createLead();
    }
  }, [teamId, departmentId]);

  useEffect(() => {
    if (getSiteList !== null) {
      (async () => {
        setIsLoading(true);
        const page = localStorage.getItem('page');
        await getFilters();
        await getSiteList(null, page);
        setIsLoading(false);
      })();
    }
  }, [getSiteList]);

  // console.log("clientStatusOptions",clientStatusOptions);
  useEffect(() => {
    if (contractStatusModalOpenForContractExpiry !== null && contractStatusModalOpenForContractExpiry==true) {
      (async () => {
        setIsLoading(true);
        await getClientStatusOptions();
        setIsLoading(false);
      })();
    }
  }, [contractStatusModalOpenForContractExpiry]);

  let roleId = parseInt(localStorage.getItem('fusion-role'));

  useEffect(() => {
    const tableData = [
      'site_id',
      "site_no",
      "site_name",
      // "client_name",
      "project_type",
      "project_id",
      "city_name",
      "live_date",
      "expiry_date",
      "commercial_type",
      "rm_name",
      "status",
      "renewal_status"
    ];

    if (siteList !== null && siteList !== undefined && siteList.data) {
      const data = siteList.data.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
            (element.renewal_status=='Not raised') ? {
              Action: [
                { name: 'View Details', link: `/dashboard/view-lead-details/${element.lead_id}` },
                { name: "Raise Renewal Request", link: '/dashboard/contract-expiry/raise-renewal-request'},
                { name: 'Update Renewal Status',link:''}
              ],
            }:(element.renewal_status=='Client approved') ?
            {
              Action: [
                { name: 'View Details', link: `/dashboard/view-lead-details/${element.lead_id}` },
                { name: 'View Raised Requests', link: `/dashboard/contract-expiry/raised-requests/${element.site_id}`},
              ]
            }
             :(element.renewal_status=='Rejected') ?
             {
               Action: [
                 { name: 'View Details', link: `/dashboard/view-lead-details/${element.lead_id}` },
                 { name: 'View Raised Requests', link: `/dashboard/contract-expiry/raised-requests/${element.site_id}`},
                 { name: "Raise Renewal Request", link: '/dashboard/contract-expiry/raise-renewal-request'},
                 { name: 'Update Renewal Status',link:''}
                 ]
             }:
            {
              Action: [
                { name: 'View Details', link: `/dashboard/view-lead-details/${element.lead_id}` },
                { name: 'View Raised Requests', link: `/dashboard/contract-expiry/raised-requests/${element.site_id}`},
                { name: "Update Renewal Request", link: '/dashboard/contract-expiry/raise-renewal-request'},
                { name: 'Update Renewal Status',link:''}
                ]
            }
        )
      );
      data && setListData(data);
      setPageCount(Math.ceil(siteList.total / siteList.per_page));
    }
  }, [siteList]);

  const applyFilter = async (filterData) => {
    setIsLoading(true);
    setFilterData(filterData);
    await getSiteList(filterData, 1);
    setIsLoading(false);
    filterToggle();
  };

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const headerBtns = () => {
    return (
      <Fragment>
        <Button
          onClick={filterToggle}
          className="filter-hamburger btn btn-transparent"
        >
          <img src={Images?.Filter} alt="" />
          {localization.showFilters}
        </Button>
      </Fragment>
    );
  };

  const onPageChange = async (val) => {
    let filter = filterData === null ? null : filterData;
    setIsLoading(true);
    await getSiteList(filter, val.selected + 1);
    localStorage.setItem('page',val.selected + 1)
    setIsLoading(false);
  };

  const statusOptions = clientStatusOptions?.status_options;

  const clientAlignedReasons = clientStatusOptions?.client_aligned_reasons;

  const clientNotAlignedReasons = clientStatusOptions?.client_not_aligned_reasons;

  const handleSuccessModalHide=()=>{
    setIsSuccessModel(false);
    window.location.reload();
  };
  const handleFailureModalHide=()=>{
    setIsFailureModel(false);
    window.location.reload();
  };

  console.log("contractExpiryStatus",contractExpiryStatus);
  return (
    
    <Layout
      title={localization.approvedSalesLeadListing}
      Buttons={headerBtns}
      isLoading={isLoading}
      isGoback
    >
      <ModalPop
                title={localization.conf}
                show={isSuccessModal}
                handleModalHide={handleSuccessModalHide}
                keyboard
                backdrop
            >
                <div className="text-center">
                    <div className="success">
                        <img src={Images?.tick} alt="" />
                    </div>
                    <h5>{localization.success}</h5>
                    <div style={{
                      display: "flex",
                      justifyContent: "center"
                      }}>
                    <Button onClick={handleSuccessModalHide} className="btn btn-transparent">
                        {localization.goBack}
                        <img src={Images?.ArrowRight} alt="" />
                    </Button>
                    </div>
                </div>
            </ModalPop>
        <ModalPop
            title={localization.conf}
            show={isFailureModal}
            handleModalHide={handleFailureModalHide}
            keyboard
            backdrop
        >
            <div className="text-center">
                <div className="success">
                    <img src={Images?.ErrorImg} alt="" style={{maxHeight:"-webkit-fill-available"}}/>
                </div>
                <h5>{localization?.oppsWrong}</h5>
                <div style={{
                  display: "flex",
                  justifyContent: "center"
                  }}>
                <Button onClick={handleFailureModalHide} className="btn btn-transparent">
                        {localization.goBack}
                        <img src={Images?.ArrowRight} alt="" />
                    </Button>
                    </div>
            </div>
        </ModalPop>
            
      <ModalPop
                title={"Update Client Alignment"}
                show={contractStatusModalOpenForContractExpiry}
                handleModalHide={() => {
                  setContractStatusModalOpenForContractExpiry(false);
                }}
            >
              <div style={{ minHeight: "250px", padding: "10px" }}>
              <DropDownInput 
                label={'Client Alignment'} 
                data={statusOptions}
                required
                getIdValue={(val) => {
                  setContractExpiryStatus({
                    site_id:requestForContractExpiry,
                    client_status: val.id,
                    client_status_reason: '',
                    client_status_reason_remarks:''
                  });
                }}
                isStarRequired={true}
                value={statusOptions?.find(option => option?.id==contractExpiryStatus?.client_status)?.name||''}
                style={{ width: "250px" }}
                />
              {
                contractExpiryStatus.client_status==1 && (
                  <DropDownInput
                    label="Alignment Reason"
                    data={clientAlignedReasons}
                    required
                    getIdValue={(val) => {
                      setContractExpiryStatus((prev) => ({
                        ...prev,
                        client_status_reason: val?.id,
                      }));
                    }}
                    isStarRequired={true}
                    value={clientAlignedReasons?.find(option => option.id==contractExpiryStatus?.client_status_reason)?.name||''}
                    style={{ width: "250px" }}
                  />
                )
                
              }
              {
                contractExpiryStatus.client_status==2 && (
                  <DropDownInput
                    label="Alignment Reason"
                    data={clientNotAlignedReasons}
                    required
                    getIdValue={(val) => {
                      setContractExpiryStatus((prev) => ({
                        ...prev,
                        client_status_reason: val?.id,
                      }));
                    }}
                    isStarRequired={true}
                    value={clientNotAlignedReasons?.find(option => option.id==contractExpiryStatus?.client_status_reason)?.name||''}
                    style={{ width: "250px" }}
                  />
                )
              }
              {
                ((contractExpiryStatus.client_status==1 && contractExpiryStatus.client_status_reason==7)||(contractExpiryStatus.client_status==2 && contractExpiryStatus.client_status_reason==6)) && (
                  <TextAreaInput
                    inputValue={contractExpiryStatus?.client_status_reason_remarks}
                    rows={1}
                    type="text"
                    label='Remarks'
                    isStarRequired={true}
                    maxLength={30}
                    handleChange={(e) => {
                      e.persist();
                      setContractExpiryStatus((prev) => ({
                        ...prev,
                        client_status_reason_remarks: e?.target?.value,
                      })
                    )}}
                  />
                )
              }
                <div className="col-md-12" style={{
                  display: "flex",
                  justifyContent: "center"
                  }}>
                    <Button  onClick={async()=>{
                      console.log("contractExpiryStatus",contractExpiryStatus);
                      if(contractExpiryStatus.client_status==''
                        ||contractExpiryStatus.client_status_reason==''
                        ||(((contractExpiryStatus.client_status==1 && contractExpiryStatus.client_status_reason==7)||(contractExpiryStatus.client_status==2 && contractExpiryStatus.client_status_reason==6))
                        && contractExpiryStatus.client_status_reason_remarks=='')){
                          toast.error("Please fill all fields");
                          return;
                        }
                      setIsLoading(true);
                      const res=await updateClientRenewalStatus(contractExpiryStatus);
                      if(res){
                        setIsSuccessModel(true);
                      }else{
                        setIsFailureModel(true);
                      }
                      setIsLoading(false);
                    }}>
                        {localization.submitDtl} 
                    </Button>                
                </div>
              </div>
            </ModalPop>
      
      <ListFilters
          showFilter={showFilter}
          filterToggle={filterToggle}
          applyFilter={(val) => applyFilter(val)}
          listFilterData={filters}
          contractRenewalFilter={true}
      />

      <TableSection
        data={listData}
        headers={headers}
        detailList={siteList && siteList.data}
        pageCount={pageCount}
        isId={false}
        srNo={siteList?.from}
        onPageChange={onPageChange}
        currentPage={localStorage.getItem('page')}
        setRequestForContractExpiry={setRequestForContractExpiry}
        setContractStatusModalOpenForContractExpiry={setContractStatusModalOpenForContractExpiry}
      />
    </Layout>
  );
};

export default ContractExpiryList;
